import { useEffect, useRef, type RefObject } from 'react';
import type { PromotionEcommerceType, TrackingEventType } from '../types/types';
import useIntersectionObserver from 'hooks/globals/useIntersectionObserver';
import trackViewPromotion from '../trackViewPromotion';

export default function useViewPromotionIntersectionObserver() {
    const hasTracked = useRef(false);

    return ({
        elementRef,
        ecommerce,
        trackingType
    }: { elementRef: RefObject<Element>; ecommerce: PromotionEcommerceType; trackingType: TrackingEventType }) => {
        const entry = useIntersectionObserver(elementRef, { threshold: 0.5 });
        const { isIntersecting } = entry || {};

        useEffect(() => {
            if (isIntersecting && !hasTracked.current) {
                trackViewPromotion({ ecommerce, trackingType });
                hasTracked.current = true;
            }
        }, [isIntersecting, ecommerce, trackingType]);
    };
}
